import addressSchemaMapper from './addressSchemaMapper';
import googleApiMapper from './googleApiMapper';
import paymentOptionsMapper from './transaction/paymentOptionsMapper';
import salonMapper from './transaction/salonMapper';
import cartItemsMapper from './transaction/cartItemsMapper';
import mpPSEPaymentOptionsMapper from './mpPSEPaymentOptionsMapper';
import deliveryMethodsMapper from './transaction/deliveryMethodsMapper';
import melissaApiMapper from './melissaApiMapper';
import shipOptionsMapper from './transaction/shipOptionsMapper';
import addressMapper from './transaction/addressMapper';
import deliveryOptionsMapper from './transaction/deliveryOptionsMapper';
import donationApiMapper from './donationApiMapper';
import clickAndCollectDataMapper from './clickAndCollectDataMapper';
import transactionMapper from './transaction/transactionMapper';
import orderSummaryMapper from './transaction/orderSummaryMapper';
import bopisInfoMapper from './transaction/bopisInfoMapper';
import siteConfigMapper from './siteConfigMapper';
import bopisStoresMapper from './bopisStoresMapper';
import estimatedDeliveryMapper from './estimatedDeliveryMapper';
import courierMapper from './courierMapper';

const DataMappings = {
  addressMapper,
  addressSchemaMapper,
  bopisInfoMapper,
  bopisStoresMapper,
  cartItemsMapper,
  clickAndCollectDataMapper,
  courierMapper,
  deliveryMethodsMapper,
  deliveryOptionsMapper,
  donationApiMapper,
  estimatedDeliveryMapper,
  googleApiMapper,
  melissaApiMapper,
  mpPSEPaymentOptionsMapper,
  orderSummaryMapper,
  paymentOptionsMapper,
  salonMapper,
  shipOptionsMapper,
  siteConfigMapper,
  transactionMapper,
};

export default DataMappings;
